<template>
    <div>
        <span
            v-if="showLang"
            style="font-size: 12px; cursor: pointer"
            v-html="
                $t('shop.includesServiceFee', {
                    price: formattedServiceFee,
                })
            "
            @click.prevent="onShowModal"
        ></span>
        <span v-else class="cursor-pointer" @click.prevent="onShowModal" v-html="formattedServiceFee"> </span>

        <modal
            ref="serviceFeeInfo"
            id="service-fee-info-modal"
            :centered="true"
            :title="$t('shop.serviceFeeInfoTitle')"
            :show="modal.show"
            :close="modal.close"
            :closeable="modal.closeable"
            @modal-close="onHideModal"
            size="modal-lg"
        >
            <div class="modal-body">
                <p
                    class="mb-0 text-left"
                    v-html="
                        $t('shop.serviceFeeInfoText', {
                            price: formattedServiceFee,
                        })
                    "
                ></p>
            </div>
            <div class="modal-footer justify-content-center">
                <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="onHideModal"
                    v-html="$t('shop.serviceFeeInfoClose')"
                ></button>
            </div>
        </modal>
    </div>
</template>

<script>
import { render, h } from 'vue';
import Price from '../Price.vue';

export default {
    props: {
        serviceFee: {
            type: Number,
            required: true,
        },
        showLang: {
            type: Boolean,
            required: false,
            default() {
                return true;
            },
        },
        showNewCurrency: {
            type: Boolean,
            required: false,
            default() {
                return true;
            },
        },
    },

    data() {
        return {
            formattedServiceFee: '',
            modal: {
                show: false,
                close: false,
                closable: true,
            },
        };
    },

    watch: {
        /**
         * @returns {void}
         */
        serviceFee() {
            this.updateFormattedPrice();
        },
    },

    methods: {
        /**
         * @returns {void}
         */
        onShowModal() {
            this.modal.close = false;
            this.modal.show = true;
        },

        /**
         * @returns {void}
         */
        onHideModal() {
            this.modal.show = false;
            this.modal.close = true;
        },

        /**
         * @returns {void}
         */
        updateFormattedPrice() {
            const element = document.createElement('div');
            render(h(Price, {
                'price': this.serviceFee,
                'inline': true,
                'currency-in-newline': true,
                'container-class': '',
                'showNewCurrency': this.showNewCurrency,
            }), element);
            this.formattedServiceFee = element.innerHTML;
            element.remove();
        },
    },

    /**
     * @returns {void}
     */
    mounted() {
        this.updateFormattedPrice();
    },
};
</script>
